import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { NotAuthenticatedUserError } from '@errors/error';
import { AuthService } from '@services/auth.service';
import { SystemAdminService } from '@services/system-admin.service';
import { map } from 'rxjs';

export const loginGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const systemAdminService = inject(SystemAdminService);

  return authService.isAuthenticated().pipe(
    map((isLoggedIn) => {
      if (isLoggedIn) {
        const loggedInUser = authService.loggedInUser;
        if (!loggedInUser) {
          throw new NotAuthenticatedUserError();
        }

        /**
         * マクニカ管理者の場合
         * ①マクニカ管理者テナントを選択していれば、デバイス管理画面へ
         * ②テナントを選択していれば、ダッシュボード画面へ
         * ③テナントが選択されていなければ、選択画面へ
         * マクニカ管理者でない場合、ダッシュボード画面へ遷移する
         */
        const roleId = loggedInUser.tenant.roleId;
        if (roleId === 'system_admin') {
          if (systemAdminService.isSelectedSystemAdminTenant) {
            return router.parseUrl('/devices');
          } else if (systemAdminService.isSelectedTenant) {
            return router.parseUrl('/dashboard');
          } else {
            return router.parseUrl('/tenant-select');
          }
        } else {
          return router.parseUrl('/dashboard');
        }
      }
      return true;
    }),
  );
};
